import React from 'react';
import { Result, Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;

interface PermissionDeniedProps {
  title?: string;
  subtitle?: string;
  currentPath?: string;
  requiredRoles?: string[];
  requiredPermission?: string;
  fallbackPath?: string;
  showBackButton?: boolean;
}

/**
 * 权限拒绝页面组件
 * 提供友好的用户反馈和导航选项
 */
export const PermissionDenied: React.FC<PermissionDeniedProps> = ({
  title = '访问被拒绝',
  subtitle = '抱歉，您没有权限访问此页面。',
  currentPath,
  requiredRoles = [],
  requiredPermission,
  fallbackPath = '/dashboard',
  showBackButton = true,
}) => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate(fallbackPath);
  };

  const handleGoBack = () => {
    window.history.back();
  };

  const getRoleDisplayName = (role: string) => {
    const roleNames: Record<string, string> = {
      admin: '管理员',
      hq_staff: '总部员工',
      warehouse_supervisor: '仓库主管',
      warehouse_staff: '仓库员工',
      main_account: '主账号',
      sub_account: '子账号',
    };
    return roleNames[role] || role;
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <Result
        status="403"
        title={title}
        subTitle={subtitle}
        extra={[
          <Button 
            type="primary" 
            key="home" 
            onClick={handleBackToHome}
            size="large"
          >
            返回首页
          </Button>,
          showBackButton && (
            <Button 
              key="back" 
              onClick={handleGoBack}
              size="large"
            >
              返回上页
            </Button>
          ),
        ].filter(Boolean)}
      >
        <div className="text-sm text-gray-500 mt-6 space-y-2">
          {currentPath && (
            <div>
              <Text strong>当前路径:</Text> {currentPath}
            </div>
          )}
          {requiredRoles.length > 0 && (
            <div>
              <Text strong>所需权限:</Text> {requiredRoles.map(getRoleDisplayName).join('、')}
            </div>
          )}
          {requiredPermission && (
            <div>
              <Text strong>所需功能权限:</Text> {requiredPermission}
            </div>
          )}
          <div className="mt-4 p-3 bg-blue-50 rounded-lg">
            <Text strong className="text-blue-800">💡 提示</Text>
            <div className="text-blue-700 mt-1">
              <p>• 如果您认为这是一个错误，请联系系统管理员</p>
              <p>• 您可能需要使用不同的账号登录</p>
              <p>• 或者联系主账号为您分配相应权限</p>
            </div>
          </div>
        </div>
      </Result>
    </div>
  );
};
